import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { GoArrowLeft } from "react-icons/go";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Login1 = ({ isOpen, onClose }) => {
  const [phone, setPhone] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [formData, setFormData] = useState({
    name: "",
    email_id: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    user_type: "Customer",
    admin_auto_id: sessionStorage.getItem("admin_auto_id"),
    country_code: "IN-91",
    country_name: "India",
  });
  const validateSignUpFields = () => {
    if (!formData.name.trim()) return "Full Name is required";
    if (!formData.email_id.trim()) return "Email is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_id))
      return "Enter valid email address";
    if (!formData.city.trim()) return "City is required";
    if (!formData.address.trim()) return "Address is required";
    if (phone.length !== 10) return "Enter valid 10-digit mobile number";
    return null;
  };

  const navigate = useNavigate();
  const [loginBannerImage, setLoginBannerImage] = useState(
    "https://placehold.co/400x400"
  );
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [themeColor, setThemeColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");
  const appName = sessionStorage.getItem('appName');
  const [resending, setResending] = useState(false);


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }
  useEffect(() => {
    if (!isSignUp || !formData.city || !formData.address) return;

    const fetchCoordinates = async () => {
      const address = `${formData.address}, ${formData.city}, ${formData.country_name}`;
      const apiKey = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";

      try {
        const response = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json",
          { params: { address, key: apiKey } }
        );

        if (response.data.status === "OK") {
          const location = response.data.results[0].geometry.location;
          setFormData((prev) => ({
            ...prev,
            latitude: location.lat,
            longitude: location.lng,
          }));
        } else {
          console.error("Geocoding API Error:", response.data.status);
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchCoordinates();
  }, [isSignUp, formData.city, formData.address]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      try {
        const parsedStyle = JSON.parse(storedStyle);
        if (parsedStyle?.login_banner_image) {
          const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/business_details/${parsedStyle.login_banner_image}`;
          setLoginBannerImage(imageUrl);
        }
      } catch (error) {
        console.error("Error parsing UIStyle from sessionStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleSendOTP = async () => {

    // 🔐 SIGN UP VALIDATION
    if (isSignUp) {
      const error = validateSignUpFields();
      if (error) {
        setMessage({ text: error, type: "error" });
        return;
      }
    }

    // 🔐 LOGIN VALIDATION
    if (!isSignUp && phone.length !== 10) {
      setMessage({ text: "Please enter a valid 10-digit phone number.", type: "error" });
      return;
    }

    setResending(true);

    try {
      const apiURL = isSignUp
        ? `${process.env.REACT_APP_API_BASE_URL}/send_registration_otp`
        : `${process.env.REACT_APP_API_BASE_URL}/send_login_otp`;

      const payload = isSignUp
        ? {
          mobile_number: phone,
          user_type: formData.user_type,
          admin_auto_id: formData.admin_auto_id,
        }
        : {
          mobile_number: phone,
          user_type: formData.user_type,
          country_code: formData.country_code,
          admin_auto_id: formData.admin_auto_id,
        };

      const response = await axios.post(apiURL, payload);

      if (response.data.status === "1") {
        setOtpSent(true);
        setMessage({ text: response.data.msg || "OTP sent successfully.", type: "success" });
      } else {
        setMessage({ text: response.data.msg || "Error sending OTP.", type: "error" });
      }
    } catch (error) {
      setMessage({
        text: "Error sending OTP: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    } finally {
      setResending(false);
    }
  };


  const handleVerifyOTP = async () => {
    try {
      const apiURL = isSignUp
        ? `${process.env.REACT_APP_API_BASE_URL}/verify_registration_otp`
        : `${process.env.REACT_APP_API_BASE_URL}/login`;

      const payload = isSignUp
        ? {
          mobile_number: phone,
          otp: otp.join(""),
          user_type: formData.user_type,
          admin_auto_id: formData.admin_auto_id,
        }
        : {
          mobile_number: phone,
          user_type: formData.user_type,
          country_code: formData.country_code,
          admin_auto_id: formData.admin_auto_id,
          otp: otp.join(""),
        };

      const response = await axios.post(apiURL, payload);

      if (response.data.status === "1") {
        sessionStorage.setItem("accessToken", response.data.user_id);
        if (isSignUp) {
          await handleUserRegistration();
        } else {
          setMessage({ text: response.data.msg || "Login successful!", type: "success" });
          setLoginSuccess(true);
          setTimeout(() => {
            onClose();
            window.location.reload();
          }, 3000);
        }
      } else {
        setMessage({ text: response.data.msg || "Error verifying OTP.", type: "error" });
      }
    } catch (error) {
      setMessage({
        text: "Error verifying OTP: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    }
  };

  const handleUserRegistration = async () => {
    if (!isSignUp) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/user_registration`,
        { ...formData, mobile_number: phone }
      );

      if (response.data.status === "1") {
        const userAutoId = response.data.user_auto_id;
        sessionStorage.setItem("accessToken", userAutoId);
        setMessage({ text: response.data.msg || "Registration successful!", type: "success" });
        setLoginSuccess(true);
        setTimeout(() => {
          onClose();
          window.location.reload();
        }, 3000);
      } else {
        setMessage({ text: response.data.msg || "Error during registration.", type: "error" });
      }
    } catch (error) {
      setMessage({
        text: "Error during registration: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setPhone(value);
    }
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  useEffect(() => {
    if (otp.every((digit) => digit !== "")) {
      handleVerifyOTP();
    }
  }, [otp]);

  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${webFont}`}>
      <div className="bg-white px-6 pt-6 pb-4 rounded-3xl shadow-lg w-[550px] relative">
        {otpSent && !loginSuccess && (
          <div className="flex flex-col items-center justify-center w-full h-full border-b-2">
            <div className="flex items-center gap-3 mb-2">
              <GoArrowLeft className="absolute text-2xl cursor-pointer top-5 left-5" onClick={onClose} />
              <h2 className="mb-0 text-xl font-semibold text-gray-500">
                OTP Verification
              </h2>
            </div>
          </div>
        )}

        {!otpSent && !loginSuccess && (
          <div className="flex flex-col items-center justify-center">
            <GoArrowLeft
              className="absolute text-2xl text-black cursor-pointer top-5 left-5"
              onClick={onClose}
            />
            <div className="flex items-center justify-center w-24 h-20 overflow-hidden rounded-lg">
              <img
                src={loginBannerImage}
                alt="logo"
                className="object-contain w-full h-full rounded"
              />
            </div>
            <h2 className="flex items-center justify-center mb-0 text-2xl font-bold text-black">
              {appName}
            </h2>
            <p className="flex items-center justify-center mb-4 text-lg font-semibold text-black">
              {isSignUp ? "Sign Up" : "Log In"}
            </p>
            {message.text && (
              <div
                className={`text-center p-2 text-sm mb-2 ${message.type === "error" ? "text-red-500" : "text-green-500"
                  }`}
              >
                {message.text}
              </div>
            )}
            {isSignUp && (
              <>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  placeholder="Full Name"
                  className="p-2 mb-2 text-black border-2 border-gray-300 w-72 rounded-xl"
                />
                <input
                  type="email"
                  name="email_id"
                  value={formData.email_id}
                  onChange={handleFormChange}
                  placeholder="Email"
                  className="p-2 mb-2 text-black border-2 border-gray-300 w-72 rounded-xl"
                />
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleFormChange}
                  placeholder="City"
                  className="p-2 mb-2 text-black border-2 border-gray-300 w-72 rounded-xl"
                />
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleFormChange}
                  placeholder="Address"
                  className="p-2 mb-4 text-black border-2 border-gray-300 w-72 rounded-xl"
                />
              </>
            )}
            <div className="flex items-center p-2 mb-4 border-2 border-gray-300 rounded-xl w-72">
              <span className="px-2 text-black">+91</span>
              <input
                type="text"
                value={phone}
                onChange={handlePhoneChange}
                maxLength={10}
                placeholder="Enter mobile number"
                className="w-full text-black outline-none"
              />
            </div>

            <div className="flex items-center justify-center gap-2">
              <button
                onClick={handleSendOTP}
                className={`w-full text-white py-2 rounded-xl p-2 ${phone.length !== 10 ? "bg-gray-300" : ""
                  }`}
                style={{
                  backgroundColor: phone.length === 10 ? themeColor : undefined,
                }}
              >
                Continue
              </button>
            </div>
            <p className="mt-4 mb-0 text-sm text-gray-400 cursor-pointer ">
              {isSignUp ? "Existing user " : "New user "}
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsSignUp(!isSignUp);
                }}
                className="no-underline"
                style={{ color: themeColor }}
                onMouseEnter={(e) => {
                  const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                  e.currentTarget.style.color = darkenedColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = themeColor;
                }}
              >
                {isSignUp ? "Log In" : "Sign Up"}
              </Link>
            </p>
            <p className="flex flex-wrap items-center justify-center gap-x-1 gap-y-1 mb-2 text-[11px] sm:text-xs text-gray-400 text-center px-2 leading-4">
              <span>By continuing, you agree to our</span>

              <Link
                className="px-1 no-underline whitespace-nowrap"
                to="/termsandcondition"
                onClick={() => onClose()}
                style={{ color: themeColor }}
                onMouseEnter={(e) => {
                  const darkenedColor = darkenHexColor(themeColor, 0.15);
                  e.currentTarget.style.color = darkenedColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = themeColor;
                }}
              >
                Terms of service
              </Link>

              <span>&</span>

              <Link
                className="px-1 no-underline whitespace-nowrap"
                to="/privacyandpolicy"
                onClick={() => onClose()}
                style={{ color: themeColor }}
                onMouseEnter={(e) => {
                  const darkenedColor = darkenHexColor(themeColor, 0.15);
                  e.currentTarget.style.color = darkenedColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = themeColor;
                }}
              >
                Privacy policy
              </Link>
            </p>

          </div>
        )}

        {otpSent && !loginSuccess && (
          <div className="flex flex-col items-center justify-center w-full h-full">
            {message.text && (
              <div
                className={`text-center p-2 Kr text-sm mb-2 ${message.type === "error" ? "text-red-500" : "text-green-500"
                  }`}
              >
                {message.text}
              </div>
            )}
            <p className="mt-2 mb-4 text-sm text-center text-gray-600">
              We have sent a verification code to <br />
              <span className="text-lg font-semibold text-gray-800">
                +91-{phone}
              </span>
            </p>
            <div className="flex justify-center gap-4 mb-4">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  maxLength={1}
                  className="text-lg text-center text-black border border-gray-300 rounded-md shadow-sm w-14 h-14 focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              ))}
            </div>
            <p className="mt-3 text-sm text-center cursor-pointer"
              onClick={handleSendOTP}
              style={{ color: themeColor }}
              onMouseEnter={(e) => {
                const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                e.currentTarget.style.color = darkenedColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = themeColor;
              }}
            >
              {resending ? "Resending..." : "Resend Code"}
            </p>
          </div>
        )}

        {loginSuccess && (
          <div className="text-center">
            <FaCheckCircle className="mx-auto text-5xl " style={{ color: themeColor }} />
            <p className="mt-4 font-semibold text-md" style={{ color: themeColor }}>
              Successfully Logged In!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login1;